module.exports = __webpack_public_path__ + "img/medium.66881e92.jpg";